import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { Laudo, SituacaoEnum, StatusCirurgiaEnum, TipoDocumentoUpload } from '@/types/_'


const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async atualizarAutorizacao(solicitacaoId: string, data: ClinicaAtualizaAutorizacaoDaSolicitacao) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/clinica/atualiza-autorizacao`, data)
    return factory.build<string>(request)
  },

  async atualizarDataAgendamento(solicitacaoId: string, data: ClinicaAtualizaDataAgendamentoDaSolicitacao) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/clinica/atualiza-data-agendamento`, data)
    return factory.build<string>(request)
  },

  async atualizarStatus(solicitacaoId: string, data: ClinicaAtualizaStatusDaSolicitacao) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/clinica/atualiza-status`, data)
    return factory.build<string>(request)
  },

  async cancelar(solicitacaoId: string, data: ClinicaFazCancelamentoDaSolicitacao) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/ClinicaFazCancelamentoDaSolicitacao`, data)
    return factory.build<string>(request)
  },

  async desfazerCancelamento(solicitacaoId: string) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/clinica/desfaz-cancelamento`, {})
    return factory.build<string>(request)
  },

  async atualizaStatusCirurgia(solicitacaoId: string, data: ClinicaAtualizaStatusCirurgia) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/atualiza-status-cirurgia/${data.statusCirurgia}`, {})
    return factory.build<string>(request)
  },

  async uploadAnexoOperadora(solicitacaoId: string, formData: any) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const tipoDocumento = TipoDocumentoUpload.AnexoOperadora

    const request = await api.upload(`/solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`, formData, headers)
    return factory.build<any>(request)
  },

  async getAnexosOperadora(solicitacaoId: string) {
    const tipoDocumento = TipoDocumentoUpload.AnexoOperadora
    const request = await api.get(`solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`)
    return factory.build<Laudo[]>(request)
  },
}

export interface ClinicaAtualizaAutorizacaoDaSolicitacao {
  autorizacaoValidade: Date;
  autorizacaoObservacao?: string;
}

export interface ClinicaAtualizaDataAgendamentoDaSolicitacao {
  dataAgendamento: string
}

export interface ClinicaAtualizaStatusDaSolicitacao {
  statusSituacao: SituacaoEnum
}

export interface ClinicaFazCancelamentoDaSolicitacao {
  motivoCancelamentoId: string
}

export interface ClinicaAtualizaStatusCirurgia {
  statusCirurgia: StatusCirurgiaEnum
}
